<template>
  <div>
    <div class="hero"
      :style="{ backgroundImage: 'url(' + require('@/assets/background.png') + ')' }">
      <h1>INTEGER FEUGIAT SCELERISQUE</h1>
      <p>{{ pageTitle }}</p>
      <ul>
        <li><a class="btn" href="#">Eleifend interdum</a></li>
        <li><a class="btn inverse" href="#">Commodo interdum</a></li>
      </ul>
    </div>

    <div class="text-container">
      <div>
        <h1>Lorem ipsum dolor sit amet</h1>
        <p>{{ pageDescription }}
        </p>
        <router-link to="/about">About Us</router-link>
      </div>
      <div>
        <img src="../assets/placeholder.png">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    name: 'Home',
    pageTitle: 'Etiam in nulla nulla nisi laoreet mattis vitae id eros etiam vehicula risus eu leo aliquam malesuada sed porta',
    pageDescription: `Felis imperdiet proin fermentum leo vel orci porta non pulvinar. At lectus urna duis convallis convallis tellus
      id interdum velit.
      Egestas pretium aenean pharetra magna ac. Purus ut faucibus pulvinar elementum integer enim neque volutpat ac.
      Est ullamcorper eget nulla facilisi etiam dignissim diam quis enim. Fermentum odio eu feugiat pretium nibh ipsum
      consequat nisl.
      Aliquam vestibulum morbi blandit cursus risus at ultrices mi tempus. Fusce id velit ut tortor pretium viverra
      suspendisse.
      Interdum velit euismod in pellentesque massa placerat duis ultricies lacus. Sed elementum tempus egestas sed sed
      risus pretium quam.
      Cursus sit amet dictum sit amet justo donec. Viverra mauris in aliquam sem fringilla ut morbi. Consequat nisl vel
      pretium lectus.
      Libero justo laoreet sit amet cursus sit amet dictum. Sit amet aliquam id diam maecenas ultricies mi eget.
      Tincidunt id aliquet risus feugiat in ante metus. Urna duis convallis convallis tellus id interdum velit.`,
  }),
};
</script>

<style scoped>
.hero {
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding-top: 150px;
  padding-bottom: 150px;
}

ul {
  list-style: none;
  display: flex;
  justify-content: center;
}

.btn {
  display: inline-block;
  padding: 10px 18px 10px;
  margin: 10px;
  text-transform: uppercase;
  border: 1px solid;
  border-radius: 22px;
  color: #ffffff;
  background-color: #03bdd2;
  border-color: #03bdd2;
  text-decoration: none;
  outline: none;
}
.btn.inverse {
  background-color: transparent;
  border-color: inherit;
}

.text-container {
  display: flex;
  margin: 50px;
}
.text-container > div {
  margin: 0 30px 0 30px;
}
.text-container a {
  font-size: 22px;
}

p {
  font-size: 22px;
}
</style>
